import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "stats" }

export function render(_ctx, _cache) {
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_col = _resolveComponent("el-col")
  const _component_GoldMedal = _resolveComponent("GoldMedal")
  const _component_User = _resolveComponent("User")
  const _component_Memo = _resolveComponent("Memo")
  const _component_ChatLineRound = _resolveComponent("ChatLineRound")
  const _component_Collection = _resolveComponent("Collection")
  const _component_el_row = _resolveComponent("el-row")
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              size: 64,
              title: "Anzahl Mandanten"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_OfficeBuilding)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              size: 64,
              title: "Anzahl Prüfungen"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_GoldMedal)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              size: 64,
              title: "Anzahl Teilnehmer"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_User)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              size: 64,
              title: "Anzahl Kategorien"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Memo)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              size: 64,
              title: "Anzahl Fragen"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ChatLineRound)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              size: 64,
              title: "Anzahl Referenzen"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Collection)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.statsModel.count_customer), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.statsModel.count_test), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.statsModel.count_participant), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.statsModel.count_category), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.statsModel.count_question), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 4,
          align: "center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.statsModel.count_reference), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}